// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__CARPx","main":"Button_main__B95NL","alt":"Button_alt__nnOzk","disable":"Button_disable__B6Tap","large":"Button_large__QQbQF"};